import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { rutaOperacion } from '../_operacion.js';

/**
 * La hoja de conteo físico de inventario. Fase 8, tarea 21.
 *
 * CUELGA DE `_operacion` PORQUE EL ESCENARIO SE LA DA AL OPERARIO: «Cuando el operario registra el
 * conteo fisico de los items del inventario». `app.registrar_conteo_inventario` no restringe rol, así
 * que el contador también podría registrar uno, pero ningún escenario se lo pide, y `_operacion` es el
 * grupo del operario y del jefe de operarios. El grupo lo decide el conjunto de roles del escenario y
 * no el tema de la pantalla, adjudicación 177.
 *
 * LA DIRECCIÓN ES `/inventario/conteo` Y NO `/conteo`: `/jornada/conteo` ya es el conteo del efectivo,
 * y dos «conteo» sin apellido en el mismo grupo se confunden en la barra de direcciones y en la cabeza
 * de quien los usa.
 *
 * El componente llega a pedido, como los demás hijos de este grupo: arrastra `@tanstack/query`, la
 * hoja y el cliente de Supabase, y nadie que todavía no entró tiene por qué descargarlos.
 */
export const rutaConteoInventario = createRoute({
  getParentRoute: () => rutaOperacion,
  path: '/inventario/conteo',
  component: lazyRouteComponent(
    () =>
      import('../../funcionalidades/movimientos-inventario-y-conteo-fisico/PaginaConteoInventario.js'),
    'PaginaConteoInventario',
  ),
});
